import React from "react";
import PortfolioItemForm from "./PortfolioItemForm";

const EMPTY_ITEM = { title: "", description: "", imageUrl: "" };
const MAX_ITEMS = 6;

const PortfolioSection = ({ items, sectionName, onChange }) => {
  const handleAdd = () => onChange([...items, { ...EMPTY_ITEM }]);

  const handleRemove = (index) => onChange(items.filter((_, i) => i !== index));

  const handleChange = (index, updated) =>
    onChange(items.map((item, i) => (i === index ? updated : item)));

  return (
    <div className="portfolioSection">
      {items.map((item, i) => (
        <PortfolioItemForm
          key={i}
          item={item}
          onChange={(updated) => handleChange(i, updated)}
          onRemove={() => handleRemove(i)}
        />
      ))}
      {items.length < MAX_ITEMS && (
        <button type="button" className="portfolioSection__add" onClick={handleAdd}>
          {sectionName ? `+ ${sectionName}を追加` : "+ 追加する"}
        </button>
      )}
    </div>
  );
};

export default PortfolioSection;
